import React from "react";
import { useDispatch } from "react-redux";
// import { logosmall } from "../../../assets";
import { NavLink } from "react-router-dom";
import { logout, logoutComplete } from "../../../redux/slice/userSlice";

import {
  FaAddressBook,
  FaBook,
  FaClipboardCheck,
  FaClipboardList,
  FaQuestionCircle,
  FaSignOutAlt,
  FaUserCircle,
  FaUsers,
} from "react-icons/fa";
import LogoContainer from "../../home/header/LogoContainer";

const AdminSideBar = () => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    dispatch(logoutComplete());
  };

  const activeLink =
    "h-14 tracking-wide flex flex-row sm:gap-6 gap-3 pl-[18px] items-center text-adminLinkPrimary bg-adminLinkPrimary/30 border-adminLinkPrimary border-l-2";
  const inActiveLink =
    "h-14 tracking-wide flex flex-row sm:gap-6 gap-3 pl-5 items-center text-adminTextSecondary hover:bg-adminLinkPrimary/20 hover:ease-in transition duration-150 w-full";

  return (
    <section className="flex-none sticky top-0 min-h-[100vh] sm:w-[250px] w-[65px] bg-adminSecondary">
      <div className="flex flex-col pt-6 gap-6">
        {/* Heading Container */}
        <div className="flex items-center flex-col ">
          {/* <img src={logosmall} className="rounded-md w-[40px]" alt="logo" /> */}
          <LogoContainer />
          {/* <span className="text-adminTextSecondary text-[18px] font-bold tracking-wider sm:block hidden">
            Admin
          </span> */}
        </div>

        {/* Navigation */}
        <div className="">
          <NavLink
            to="/admin/home"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaUsers />
            <span className="sm:block hidden">Users</span>
          </NavLink>

          <NavLink
            to="/admin/question"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaQuestionCircle />
            <span className="sm:block hidden">Question</span>
          </NavLink>
          <NavLink
            to="/admin/exam"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaClipboardList />
            <span className="sm:block hidden">Exams</span>
          </NavLink>
          <NavLink
            to="/admin/result"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaClipboardCheck />
            <span className="sm:block hidden">Result</span>
          </NavLink>
          <NavLink
            to="/admin/topics"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaBook />
            <span className="sm:block hidden">Topics</span>
          </NavLink>
          <NavLink
            to="/admin/contactus"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaAddressBook />
            <span className="sm:block hidden">Contact Us</span>
          </NavLink>
        </div>
        <div>
          <NavLink
            to="/admin/profile"
            className={({ isActive }) => (isActive ? activeLink : inActiveLink)}
          >
            <FaUserCircle />
            <span className="sm:block hidden">Profile</span>
          </NavLink>
          <button
            onClick={handleLogout}
            type="button"
            className={`${inActiveLink}`}
          >
            <FaSignOutAlt />
            <span className="sm:block hidden">Logout </span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default AdminSideBar;
